import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Navigation, Pagination, Lazy]);
import resize from "../resize";

const initParticipantsSlider = () => {
  const slider = document.querySelector("[data-participants-slider]");
  if (!slider) return;

  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(slider, {
        lazy: true,
        watchOverflow: true,
        speed: 700,
        autoHeight: false,
        breakpoints: {
          0: {
            spaceBetween: 23,
            slidesPerView: 1.06
          },
        },
        pagination: {
          el: slider.querySelector(".swiper-pagination"),
          type: "fraction",
        },
        navigation: {
          nextEl: slider.querySelector(".slider-navigation__button--next"),
          prevEl: slider.querySelector(".slider-navigation__button--prev"),
        },
      });
    }
  }

  function destroy() {
    if (swiper) {
      swiper.destroy();
      swiper = null;
    }
  }

  function resizeSwiper() {
    window.innerWidth < 768 ? init() : destroy();
  }

  slider && resizeSwiper();
  slider && resize(resizeSwiper);
};

export default initParticipantsSlider;
